import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ThemeProvider, THEME_ID } from "@mui/material/styles";
import { CssVarsProvider as JoyCssVarsProvider } from "@mui/joy/styles";
import theme from "./theme";
import './css/style.css';

// components
import ProgressWait from "./components/ProgressWait";

// routes
const Exchanger = lazy(() => import("./routes/Exchanger"));
const HomeExchanger = lazy(() => import("./routes/HomeExchanger"));
const Admin = lazy(() => import("./routes/Admin"));
const Error = lazy(() => import("./routes/Error"));

const App = () => {

  return (
    <ThemeProvider theme={{ [THEME_ID]: theme }}>
      <JoyCssVarsProvider>
        <Router>
          <Suspense fallback={<ProgressWait />}>
            <Switch>
              <Route exact path="/" component={HomeExchanger} />
              <Route exact path="/:lang/sid=:id/:plus" component={Exchanger} />
              <Route exact path="/:lang/sid=:id/categories" component={Exchanger} />
              <Route exact path="/:lang/sid=:id" component={Exchanger} />
              <Route exact path="/admin" component={Admin} />
              <Route component={Error} />
            </Switch>
          </Suspense>
        </Router>
      </JoyCssVarsProvider>
    </ThemeProvider>
  );
};

export default App;

